/*
 * types/services/dr2am.tasks.preferences.proto
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: version not set
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.21
 *
 * Do not edit the class manually.
 *
 */

import {ApiClient} from '../ApiClient';
import {PbPreference} from './PbPreference';
import {PbResponseState} from './PbResponseState';

/**
 * The ServiceUpdatePreferenceResponse model module.
 * @module model/ServiceUpdatePreferenceResponse
 * @version version not set
 */
export class ServiceUpdatePreferenceResponse {
  /**
   * Constructs a new <code>ServiceUpdatePreferenceResponse</code>.
   * @alias module:model/ServiceUpdatePreferenceResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ServiceUpdatePreferenceResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ServiceUpdatePreferenceResponse} obj Optional instance to populate.
   * @return {module:model/ServiceUpdatePreferenceResponse} The populated <code>ServiceUpdatePreferenceResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ServiceUpdatePreferenceResponse();
      if (data.hasOwnProperty('preference'))
        obj.preference = PbPreference.constructFromObject(data['preference']);
      if (data.hasOwnProperty('state'))
        obj.state = PbResponseState.constructFromObject(data['state']);
    }
    return obj;
  }
}

/**
 * @member {module:model/PbPreference} preference
 */
ServiceUpdatePreferenceResponse.prototype.preference = undefined;

/**
 * @member {module:model/PbResponseState} state
 */
ServiceUpdatePreferenceResponse.prototype.state = undefined;


